<template>
  <div :class="skinType == 2 ? 'more_box bg_gray' : 'more_box bg_white'">
    <div class="m-table-nav">
      <div class="fscreen-back" @click.stop="fullScreen" v-if="isFullScreen"></div>
      <span
        :class="topNavId === item.key ? 'active' : ''"
        v-for="item in topNavList"
        :key="item.key"
        @click="checkTopNav(item.key)"
        >{{ item.name }}</span
      >
    </div>
    <div class="main">
      <div class="loading-wrap" v-if="loading">
        <img class="loading_img" src="../assets/images/loading.png" alt="" />
      </div>
      <div class="empty" v-if="isEmpty">暂无数据</div>
      <div class="m-report clearfix" v-if="!isEmpty">
        <div class="sea-btn" v-if="foodType !== 'first'">
          <em @click="seaTab(0)" :class="seaOn === 0 ? 'active' : ''">报告期</em>
          <em @click="seaTab(1)" :class="seaOn === 1 ? 'active' : ''">单季度</em>
        </div>
        <div class="radio" @click="changeEmptyField">
          <i :class="blankLines ? 'icon-radio' : 'icon-radio active'"></i>
          隐藏空行
        </div>
      </div>
      <div class="m-table clearfix" id="table_box" v-if="!isEmpty && !noDataShow">
        <i :class="fixed ? 'triangle right fixed' : 'triangle right'"></i>
        <dl class="m-table-title">
          <template v-for="(item, index) in gridColumns">
            <dt
              :key="index"
              class="dt_dom"
              :class="{
                'm-table-radio': index === 0,
                bold: item.type == 0,
                fixed: fixed,
              }"
              v-if="showKeys.indexOf(item.key) < 0"
            >
              <div v-if="index === 0" class="w100p">
                <i class="triangle left"></i>
                <div class="m-t-2 m-r-5" @click="changeRadio" v-if="seaOn === 0">
                  <i class="icon-radio" :class="{ active: tongbi }"></i>{{ "同比" }}
                </div>
              </div>
              <a
                href="javascript:void(0);"
                v-if="index !== 0 && item.key !== '' && item.dataType !== 'tit'"
                @click="goLinkDetail(item)"
                ><span :class="checkIndext(item.type)">{{ item.name }}</span></a
              >
              <div v-else>{{ item.name }}</div>
            </dt>
          </template>
        </dl>
        <div class="m-table-con" @scroll="scrollHead" id="scrollHeadDom">
          <div
            class="m-table-fixed"
            :style="{ width: contentWidth + 'px' }"
            v-show="fixed"
            id="fixedDom"
          >
            <template v-for="(item, index) in dataQuery">
              <span :key="index">
                {{ item.bglx }}
              </span>
              <span :key="'tb' + index" v-if="tongbi">同比</span>
            </template>
          </div>
          <div
            class="m-table-scroll"
            :style="{ width: (tongbi ? tabWidth * 2 : tabWidth) + 'rem' }"
          >
            <dl>
              <template v-for="(item, index) in dataQuery">
                <dd :key="index">
                  {{ item.bglx }}
                </dd>
                <dd :key="'tb' + index" v-if="tongbi">同比</dd>
              </template>
            </dl>
            <template v-for="(gridItem, gridIndex) in gridColumns">
              <dl
                :key="gridIndex"
                :class="{ bold: gridItem.type == 0 }"
                v-if="
                  JSON.stringify(gridItem) !== '{}' && showKeys.indexOf(gridItem.key) < 0
                "
              >
                <template v-for="(item, index) in dataQuery">
                  <dd :key="index">
                    {{
                      gridItem.key === "cur"
                        ? item["cur"]
                        : seaOn === 0
                        ? checkData(item[gridItem.key], gridItem.len, gridItem.unit)
                        : checkData(
                            item.singleInfo[gridItem.key],
                            gridItem.len,
                            gridItem.unit
                          )
                    }}
                  </dd>
                  <dd
                    :key="'dd' + index"
                    v-if="tongbi"
                    :class="item.yoyInfo[gridItem.key] | zygdColor"
                  >
                    {{
                      gridItem.key === "cur"
                        ? checkMoney(item["cur"])
                        : gridItem.key
                        ? checkData(item.yoyInfo[gridItem.key], 2, "%")
                        : ""
                    }}
                  </dd>
                </template>
              </dl>
            </template>
          </div>
        </div>
      </div>
      <div class="empty" v-if="noDataShow">暂无数据</div>
      <div
        v-if="version >= 9.59"
        class="fullscreen"
        ref="fullscreen"
        @touchmove="onDrag"
        @touchstart="onDragStart"
        @touchend="onDragEnd"
        @click="fullScreen"
      >
        <img :src="fullScreenHide ? exit_img : full_img" />
      </div>
    </div>
    <footer class="footer">
      <ul class="report_type">
        <li
          v-for="val in reportType"
          :key="val.type"
          :class="foodType === val.type ? 'active' : ''"
          @click="switchTab(val.type)"
        >
          {{ val.name }}
        </li>
      </ul>
    </footer>
  </div>
</template>
<script>
import mixins from "../mixins/index";
import { getCwMore } from "../api/index.js";
export default {
  name: "Cwts",
  data() {
    return {
      skinType: 2,
      loading: false, //loading
      isEmpty: false, //暂无数据显示隐藏
      blankLines: false, //是否显示空行数据
      seaOn: 0, //判断当前选择是报告期还是单季度数据
      tongbi: false, //判断是同比还是环比
      tabWidth: 0, //table宽度
      dataQuery: [], // 请求过来的数据
      gridColumns: [], //需要显示的吧标题列表
      headTop: 0,
      fixed: false,
      contentWidth: 0,
      topNavList: [
        { name: "主要指标", key: "zyzb" },
        { name: "利润表", key: "lrb" },
        { name: "资产负债表", key: "zcfz" },
        { name: "现金流量表", key: "xjll" },
      ],
      topNavId: "zyzb", // 当前数据类型
      foodType: "newly", //当前报告期
      reportType: [
        {
          num: 0,
          type: "newly",
          name: "最新",
          report: "",
        },
        {
          num: 1,
          type: "annal",
          name: "年报",
          report: "4",
        },
        {
          num: 2,
          type: "middle",
          name: "中报",
          report: "2",
        },
        {
          num: 3,
          type: "first",
          name: "一季度",
          report: "1",
        },
        {
          num: 4,
          type: "third",
          name: "三季度",
          report: "3",
        },
      ], //页面底部数据
      zyzb: [
        {},
        {
          name: "关键指标",
          key: "zyzb_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        { name: "营业总收入", key: "biztotinco", type: 1, unit: "元", len: 2 },
        { name: "净利润", key: "netprofit", type: 1, unit: "元", len: 2 },
        {
          name: "每股指标",
          key: "mgzb_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        { name: "基本每股收益", key: "basicepsn", type: 1, unit: "", len: 4 },
        { name: "稀释每股收益", key: "dilutedepsn", type: 1, unit: "", len: 4 },
        { name: "每股净资产", key: "mgjzc", type: 1, unit: "", len: 4 },
        { name: "每股现金流", key: "mgxjl", type: 1, unit: "", len: 4 },
        { name: "每股营业收入", key: "mgyyzsr", type: 1, unit: "", len: 4 },
        { name: "每股派息", key: "dividpshare", type: 1, unit: "", len: 4 },
        {
          name: "盈利能力",
          key: "ylnl_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        { name: "净资产收益率ROE", key: "roe", type: 1, unit: "%", len: 2 },
        { name: "摊薄净资产收益率", key: "jzcsyl", type: 1, unit: "%", len: 2 },
        { name: "总资产收益率ROA", key: "roa", type: 1, unit: "%", len: 2 },
        { name: "总资产回报率", key: "zzchbl", type: 1, unit: "%", len: 2 },
        { name: "销售毛利率", key: "sgpmargin", type: 1, unit: "%", len: 2 },
        { name: "销售净利率", key: "npmarginonsale", type: 1, unit: "%", len: 2 },
        { name: "税前利润率", key: "pretaxpmargin", type: 1, unit: "%", len: 2 },
        { name: "销售成本率", key: "scostrt", type: 1, unit: "%", len: 2 },
        {
          name: "资本结构",
          key: "zbjg_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        { name: "资产负债率", key: "zcfzl", type: 1, unit: "%", len: 2 },
        { name: "权益乘数", key: "em", type: 1, len: 2, unit: "" },
        { name: "产权比率", key: "equrt", type: 1, len: 2, unit: "%" },
        { name: "流动资产/总资产", key: "casestdivtassest", type: 1, len: 2, unit: "%" },
        {
          name: "非流动资产/总资产",
          key: "ncasestdivtassest",
          type: 1,
          len: 2,
          unit: "%",
        },
        { name: "流动负债/总负债", key: "cliabdivtliab", type: 1, len: 2, unit: "%" },
        { name: "非流动负债/总负债", key: "ncliabdivtliab", type: 1, len: 2, unit: "%" },
        {
          name: "偿债能力",
          key: "cznl_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        { name: "流动比率", key: "currentrt", type: 1, unit: "", len: 2 },
        { name: "速动比率", key: "quickrt", type: 1, unit: "", len: 2 },
        { name: "现金比率", key: "cashrt", type: 1, unit: "", len: 2 },
        {
          name: "经营活动产生的现金流量净额/流动负债",
          key: "opncashfdivcliab",
          type: 1,
          len: 2,
        },
        {
          name: "经营活动产生的现金流量/总负债",
          key: "opcashfdivtliab",
          type: 1,
          len: 2,
        },
        {
          name: "营运能力",
          key: "yynl_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        { name: "存货周转率(次)", key: "invturnrt", type: 1, unit: "", len: 2 },
        { name: "流动资产周转率(次)", key: "curassturnrt", type: 1, unit: "", len: 2 },
        { name: "固定资产周转率(次)", key: "faturnrt", type: 1, unit: "", len: 2 },
        { name: "总资产周转率 (次)", key: "taturnrt", type: 1, len: 2 },
        { name: "报告币种", key: "cur", type: 1, len: 2, unit: "not" },
      ],
      lrb: [
        {},
        { name: "营业收入", key: "biztotinco", type: 0, unit: "元", len: 2 },
        { name: "主营收入", key: "bizinco", type: 2, unit: "元", len: 2 },
        { name: "营业成本", key: "bizcost", type: 0, unit: "元", len: 2 },
        { name: "毛利", key: "grossprofit", type: 0, unit: "元", len: 2 },
        { name: "减: 营业支出", key: "bizexpe", type: 1, unit: "元", len: 2 },
        { name: "减值损失", key: "impairmentloss", type: 1, unit: "元", len: 2 },
        { name: "营业利润", key: "perprofit", type: 0, unit: "元", len: 2 },
        {
          name: "非经常性项目净损益",
          key: "noftprobprofits",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "加：利息收入", key: "inteinco", type: 1, unit: "元", len: 2 },
        { name: "减：利息支出", key: "inteexpe", type: 1, unit: "元", len: 2 },
        {
          name: "加：权益性投资损益",
          key: "equityinvestgal",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "其他非经营性损益",
          key: "othnoperprofital",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "税前利润", key: "totprofit", type: 0, unit: "元", len: 2 },
        { name: "所得税支出", key: "incotaxexpe", type: 1, unit: "元", len: 2 },
        {
          name: "加：非持续经营净利润",
          key: "notconopernprofit",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "净利润", key: "netprofit", type: 0, unit: "元", len: 2 },
        {
          name: "归属于母公司股东的净利润",
          key: "netparecompprof",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "归属于少数股东的利润",
          key: "minysharrigh",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "归属于非股东利润",
          key: "percapstockholders",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "其他综合收益", key: "othercompinco", type: 1, unit: "元", len: 2 },
        { name: "综合全面收益", key: "compincoamt", type: 0, unit: "元", len: 2 },
        {
          name: "归属于母公司股东的综合收益",
          key: "parecompincoamt",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "归属于少数股东的综合收益",
          key: "minysharincoamt",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "基本每股收益（持续）", key: "basicepsn", type: 0, unit: "", len: 2 },
        { name: "稀释每股收益（持续）", key: "dilutedepsn", type: 0, unit: "", len: 2 },
        { name: "报告币种", key: "cur", type: 1, unit: "not", len: 2 },
      ],
      zcfz: [
        {},
        {
          name: "报表核心指标",
          key: "bbhxzb_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        {
          name: "所有者权益 (或股东权益)合计",
          key: "righaggr",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "资产总计", key: "totasset", type: 1, unit: "元", len: 2 },
        { name: "流动资产合计", key: "totcurrasset", type: 2, unit: "元", len: 2 },
        { name: "非流动资产合计", key: "totalnoncassets", type: 2, unit: "元", len: 2 },
        { name: "负债合计", key: "totliab", type: 1, unit: "元", len: 2 },
        { name: "流动负债合计", key: "totalcurrliab", type: 2, unit: "元", len: 2 },
        { name: "非流动负债合计", key: "totalnoncliab", type: 2, unit: "元", len: 2 },
        {
          name: "归属于母公司股东权益合计",
          key: "paresharrigh",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "报表全部指标",
          key: "bbqbzb_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        { name: "流动资产合计", key: "totcurrasset", type: 1, unit: "元", len: 2 },
        { name: "现金及现金等价物", key: "curfds", type: 2, unit: "元", len: 2 },
        { name: "交易性金融资产", key: "tradfinasset", type: 2, unit: "元", len: 2 },
        { name: "应收帐款及票据", key: "notesaccorece", type: 2, unit: "元", len: 2 },
        { name: "存货", key: "inve", type: 2, unit: "元", len: 2 },
        { name: "其他流动资产", key: "othcurrasset", type: 2, unit: "元", len: 2 },
        {
          name: "非流动资产资产合计",
          key: "totalnoncassets",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "固定资产", key: "fixedassenetw", type: 2, unit: "元", len: 2 },
        { name: "长期股权投资", key: "ltstockinvest", type: 2, unit: "元", len: 2 },
        { name: "无形资产", key: "intaasset", type: 2, unit: "元", len: 2 },
        { name: "商誉", key: "goodwill", type: 2, unit: "元", len: 2 },
        {
          name: "租赁土地款项及土地使用权",
          key: "lleapayaluser",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "递延所得税资产", key: "defetaxasset", type: 2, unit: "元", len: 2 },
        { name: "投资性房地产", key: "investrestate", type: 2, unit: "元", len: 2 },
        { name: "其他非流动资产", key: "othernoncasse", type: 2, unit: "元", len: 2 },
        { name: "资产总计", key: "totasset", type: 1, unit: "元", len: 2 },
        { name: "流动负债合计", key: "totalcurrliab", type: 1, unit: "元", len: 2 },
        { name: "短期借贷", key: "shorttermborr", type: 2, unit: "元", len: 2 },
        {
          name: "贸易应付款项及应付票据",
          key: "notesaccopaya",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "交易性金融负债", key: "tradfinliab", type: 2, unit: "元", len: 2 },
        { name: "应付股利", key: "dividrece", type: 2, unit: "元", len: 2 },
        { name: "应付税项", key: "taxpayable", type: 2, unit: "元", len: 2 },
        { name: "其他流动负债", key: "othalcurrliab", type: 2, unit: "元", len: 2 },
        { name: "非流动负债合计", key: "totalnoncliab", type: 1, unit: "元", len: 2 },
        { name: "长期借贷", key: "longborr", type: 2, unit: "元", len: 2 },
        { name: "其它非流动负债", key: "othalnoncliab", type: 2, unit: "元", len: 2 },
        { name: "负债总计", key: "totliab", type: 1, unit: "元", len: 2 },
        {
          name: "所有者权益 (或股东权益)合计",
          key: "righaggr",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "优先股", key: "preferredstock", type: 2, unit: "元", len: 2 },
        { name: "库存股", key: "treasurystock", type: 2, unit: "元", len: 2 },
        { name: "股本", key: "capitalstock", type: 2, unit: "元", len: 2 },
        { name: "储备", key: "reserve", type: 2, unit: "元", len: 2 },
        { name: "未分配利润", key: "undiprof", type: 2, unit: "元", len: 2 },
        {
          name: "归属于母公司股东权益合计",
          key: "paresharrigh",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "少数股东权益", key: "minysharrigh", type: 2, unit: "元", len: 2 },
        {
          name: "股东权益及负债总额",
          key: "totliabsharequi",
          type: 1,
          unit: "元",
          len: 2,
        },

        { name: "报告币种", key: "cur", type: 1, unit: "not", len: 2 },
      ],
      xjll: [
        {},
        {
          name: "报表核心指标",
          key: "bbhxzb_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        {
          name: "现金及现金等价物净增加额",
          key: "cashnetr",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "经营活动产生的现金流净额",
          key: "mananetr",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "投资活动产生的现金流净额",
          key: "invnetcashflow",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "筹资活动产生的现金流净额",
          key: "finnetcflow",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "现金及现金等价物的年末余额",
          key: "fincashbala",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "报表全部指标",
          key: "bbqbzb_tit",
          type: 0,
          unit: "not",
          len: 2,
          dataType: "tit",
        },
        {
          name: "一、经营活动产生的现金流净额",
          key: "mananetr",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "税前利润", key: "btaxprofit", type: 2, unit: "元", len: 2 },
        { name: "折旧与摊销", key: "deprecamortiza", type: 2, unit: "元", len: 2 },
        { name: "营运资本变动", key: "wcapitalchg", type: 2, unit: "元", len: 2 },
        { name: "已缴税款", key: "paidtax", type: 2, unit: "元", len: 2 },
        { name: "其他非现金调整", key: "othncashitemsad", type: 2, unit: "元", len: 2 },
        {
          name: "二、投资活动产生的现金流净额",
          key: "invnetcashflow",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "投资活动现金流入小计", key: "invcashinfl", type: 1, unit: "元", len: 2 },
        {
          name: "处置固定资产、无形资产和其他长期资产所收回的现金",
          key: "fixedassetnetc",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "出售金融资产产生的现金流入",
          key: "salefinasstflow",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "股权投资产生的现金流入",
          key: "equitycashflow",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "股利利息收入", key: "divinterestinc", type: 2, unit: "元", len: 2 },
        {
          name: "借出借款收回产生的现金流入",
          key: "llrecgencashif",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "关联方归还借款", key: "relpartyloan", type: 2, unit: "元", len: 2 },
        {
          name: "其他与投资活动有关的现金流入",
          key: "othinvcashflow",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "投资活动现金流出小计", key: "invcashoutf", type: 1, unit: "元", len: 2 },
        { name: "资本支出", key: "capitalspending", type: 2, unit: "元", len: 2 },
        {
          name: "购入金融资产产生的现金流出",
          key: "bfinassetsc",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "股权投资产生的现金流出",
          key: "equityinvestc",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "借出借款产生的现金流出",
          key: "lbcashoutflow",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "借予关联方款项", key: "lrelaparties", type: 2, unit: "元", len: 2 },
        {
          name: "其他与投资活动有关的现金流出",
          key: "othequityint",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "三、筹资活动产生的现金流净额",
          key: "finnetcflow",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "筹资活动现金流入小计", key: "fincashinfl", type: 1, unit: "元", len: 2 },
        { name: "权益增加", key: "equitybuildup", type: 2, unit: "元", len: 2 },
        { name: "债务增加", key: "debtsbigger", type: 2, unit: "元", len: 2 },
        {
          name: "其他筹资活动产生的现金流入",
          key: "othfincashinfl",
          type: 2,
          unit: "元",
          len: 2,
        },
        { name: "筹资活动现金流出小计", key: "fincashoutf", type: 1, unit: "元", len: 2 },
        { name: "权益减少", key: "equitydecreases", type: 2, unit: "元", len: 2 },
        { name: "债务减少", key: "debtsdecreases", type: 2, unit: "元", len: 2 },
        {
          name: "支付股利、利息产生的现金流出",
          key: "paydivintcof",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "其他筹资活动产生的现金流出",
          key: "othfincflow",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "四、汇率变动对现金及现金等价物的影响",
          key: "chgexchgchgs",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "五、现金及现金等价物净增加额",
          key: "cashnetr",
          type: 1,
          unit: "元",
          len: 2,
        },
        {
          name: "加：现金及现金等价物的年初余额",
          key: "inicashbala",
          type: 2,
          unit: "元",
          len: 2,
        },
        {
          name: "六、现金及现金等价物的年末余额",
          key: "fincashbala",
          type: 1,
          unit: "元",
          len: 2,
        },
        { name: "报告币种", key: "cur", type: 1, unit: "not", len: 2 },
      ],
      showKeys: [],
      fullScreenHide: false, //翻转页面按钮
      point: {},
      version: 0,
      full_img: require("../assets/images/full_img.png"),
      exit_img: require("../assets/images/exit-fullscreen.png"),
      isFullScreen: false,

      noDataShow: false, //判断当前报告期是否有数据

      widthNum: 0,
    };
  },
  mixins: [mixins],
  created() {
    if (this.getUrlQuery("themeStyleVs") == 2) {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#0d1018;color: #637693;");
    } else {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#f1f1f1;color: #666;");
    }
    this.skinType = this.getUrlQuery("themeStyleVs");
    this.topNavId = this.getUrlQuery("type");
    this.version = Number(this.getUrlQuery("version"));
    this.gridColumns = this[this.topNavId];
  },
  mounted() {
    this.queryData();
  },
  watch: {
    topNavId: {
      handler(newval, old) {
        if (newval === "zyzb") {
          document.title = "主要指标";
        } else if (newval === "lrb") {
          document.title = "利润表";
        } else if (newval === "zcfz") {
          document.title = "资产负债表";
        } else if (newval === "xjll") {
          document.title = "现金流量表";
        }
      },
      immediate: true,
    },
  },
  methods: {
    checkTopNav: function (key) {
      let that = this;
      that.topNavId = key;
      that.dataQuery = [];
      that.seaOn = 0;
      that.tongbi = false;
      that.showKeys = [];
      that.gridColumns = this[key];
      that.$nextTick(function () {
        that.queryData();
      });
    },
    queryData: function () {
      let that = this;
      that.loading = true;
      let code = that.getUrlQuery("code");
      let url =
        window.config.url +
        "/wap/data/ipad/stock/HK/" +
        code.substr(-2) +
        "/" +
        code.substr(2) +
        "/f10/" +
        that.topNavId +
        "_more_" +
        that.foodType +
        ".json";
      getCwMore(url)
        .then((res) => {
          that.dataQuery = res;
          that.loading = false;
          that.isEmpty = false;
          if (res.length > 0) {
            that.noDataShow = false;
            that.$nextTick(function () {
              that.showKeys = [];
              if (!that.blankLines) {
                that.renderHtml();
              } else {
                that.showKeys = [];
              }
              let table = document.getElementById("table_box");
              let top = that.getOffsetTop(table);
              this.headTop = top;
              window.addEventListener("scroll", () => {
                that.scroll();
              });
              that.ddHeight();
            });
          } else {
            that.noDataShow = true;
          }
        })
        .catch(function () {
          that.loading = false;
          that.isEmpty = true;
        });
    },
    ddHeight: function () {
      let tabTit = document.getElementsByClassName("dt_dom");
      this.tabWidth = this.dataQuery.length * 2.12 + 10 / 50;
      for (let i = 0; i < tabTit.length; i++) {
        let $dd = document.getElementsByClassName("m-table-scroll")[0].children[i];
        if ($dd) {
          let $dds = $dd.children[0];
          if ($dds) {
            let height = tabTit[i].getBoundingClientRect().height - 0.05 + "px";
            $dd.style.height = height;
          }
        }
      }
    },
    // 点击同比显示同比数据
    changeRadio: function () {
      let that = this;
      that.tongbi = !this.tongbi;
    },
    // 点击报告期和单季度数据显示切换
    seaTab: function (type) {
      let that = this;
      if (type === this.seaOn) return;
      this.seaOn = type;
      this.tongbi = false;
      this.showKeys = [];
      if (!this.blankLines) {
        this.renderHtml();
      } else {
        this.showKeys = [];
      }
      if (type === 1) {
        let data = that.dataQuery;
        let newData = [];
        data.forEach(function (item) {
          if (JSON.stringify(item.singleInfo) !== "{}") {
            newData.push(item);
          }
        });
        if (newData.length > 0) {
          that.noDataShow = false;
          that.$nextTick(function () {
            that.ddHeight();
          });
        } else {
          that.noDataShow = true;
        }
      } else {
        if (that.dataQuery.length > 0) {
          that.noDataShow = false;
        } else {
          that.noDataShow = true;
        }
        that.$nextTick(function () {
          that.ddHeight();
        });
      }
    },
    // 处理页面中数据（小数点以及数据单位）
    checkData: function (num, len, util) {
      if (util === "元") {
        return this.process(num, len);
      } else if (util === "%") {
        return this.gainsCheck(num, len, util);
      } else if (util === "not") {
        return;
      } else {
        return this.gainsCheck(num, len, "");
      }
    },
    // 处理隐藏空行逻辑
    changeEmptyField: function () {
      let that = this;
      that.blankLines = !that.blankLines;
      that.showKeys = [];
      that.$nextTick(function () {
        if (!that.blankLines) {
          // 隐藏空数据
          that.renderHtml();
        } else {
          // 显示空数据
          that.showKeys = [];
        }
        that.ddHeight();
      });
    },
    // 过滤页面中空数据
    renderHtml: function () {
      let that = this;
      let dataKey = that.gridColumns.filter((item) => {
        return item.key && item.key !== "cur" && item.dataType !== "tit";
      });
      let dataQuery = that.dataQuery;
      let notShow = [];
      dataKey.forEach((item) => {
        let arr = [];
        dataQuery.forEach((queryItem) => {
          if (that.seaOn === 0) {
            if (queryItem[item.key]) arr.push(queryItem[item.key]);
          } else {
            if (queryItem.singleInfo[item.key]) arr.push(queryItem.singleInfo[item.key]);
          }
        });
        if (arr.length === 0) notShow.push(item.key);
      });
      let key = that.topNavId;
      if (key === "zyzb") {
        if (!that.checkShowBt(["biztotinco", "netprofit"], notShow, "zyzb_tit")) {
          notShow.push("zyzb_tit");
        }
        if (
          !that.checkShowBt(
            ["basicepsn", "dilutedepsn", "mgjzc", "mgxjl", "mgyyzsr", "dividpshare"],
            notShow,
            "mgzb_tit"
          )
        ) {
          notShow.push("mgzb_tit");
        }
        if (
          !that.checkShowBt(
            [
              "roe",
              "jzcsyl",
              "roa",
              "zzchbl",
              "sgpmargin",
              "npmarginonsale",
              "pretaxpmargin",
              "scostrt",
            ],
            notShow,
            "ylnl_tit"
          )
        ) {
          notShow.push("ylnl_tit");
        }
        if (
          !that.checkShowBt(
            [
              "zcfzl",
              "em",
              "equrt",
              "casestdivtassest",
              "ncasestdivtassest",
              "cliabdivtliab",
              "ncliabdivtliab",
            ],
            notShow,
            "zbjg_tit"
          )
        ) {
          notShow.push("zbjg_tit");
        }
        if (
          !that.checkShowBt(
            ["currentrt", "quickrt", "cashrt", "opncashfdivcliab", "opcashfdivtliab"],
            notShow,
            "cznl_tit"
          )
        ) {
          notShow.push("cznl_tit");
        }
        if (
          !that.checkShowBt(
            ["invturnrt", "curassturnrt", "faturnrt", "taturnrt"],
            notShow,
            "yynl_tit"
          )
        ) {
          notShow.push("yynl_tit");
        }
      }
      if (key === "zcfz") {
        if (
          !that.checkShowBt(
            [
              "righaggr",
              "totasset",
              "totcurrasset",
              "totalnoncassets",
              "totalcurrliab",
              "totalnoncliab",
              "paresharrigh",
            ],
            notShow,
            "bbhxzb_tit"
          )
        ) {
          notShow.push("bbhxzb_tit");
        }
        let yynlArr = [
          "totcurrasset",
          "curfds",
          "tradfinasset",
          "notesaccorece",
          "inve",
          "othcurrasset",
          "totalnoncassets",
          "fixedassenetw",
          "ltstockinvest",
          "intaasset",
          "goodwill",
          "lleapayaluser",
          "defetaxasset",
          "investrestate",
          "othernoncasse",
          "totasset",
          "totalcurrliab",
          "shorttermborr",
          "notesaccopaya",
          "tradfinliab",
          "dividrece",
          "taxpayable",
          "othalcurrliab",
          "totalnoncliab",
          "longborr",
          "othalnoncliab",
          "totliab",
          "righaggr",
          "preferredstock",
          "treasurystock",
          "capitalstock",
          "reserve",
          "undiprof",
          "paresharrigh",
          "minysharrigh",
          "totliabsharequi",
        ];
        if (!that.checkShowBt(yynlArr, notShow, "bbqbzb_tit")) {
          notShow.push("bbqbzb_tit");
        }
      }
      if (key === "xjll") {
        if (
          !that.checkShowBt(
            ["cashnetr", "mananetr", "invnetcashflow", "finnetcflow", "fincashbala"],
            notShow,
            "bbhxzb_tit"
          )
        ) {
          notShow.push("bbhxzb_tit");
        }
        let bbqbzbList = [
          "mananetr",
          "btaxprofit",
          "deprecamortiza",
          "wcapitalchg",
          "paidtax",
          "othncashitemsad",
          "invnetcashflow",
          "invcashinfl",
          "fixedassetnetc",
          "salefinasstflow",
          "equitycashflow",
          "divinterestinc",
          "llrecgencashif",
          "relpartyloan",
          "othinvcashflow",
          "invcashoutf",
          "capitalspending",
          "bfinassetsc",
          "equityinvestc",
          "lbcashoutflow",
          "lrelaparties",
          "othequityint",
          "finnetcflow",
          "fincashinfl",
          "equitybuildup",
          "debtsbigger",
          "othfincashinfl",
          "fincashoutf",
          "equitydecreases",
          "debtsdecreases",
          "paydivintcof",
          "othfincflow",
          "chgexchgchgs",
          "cashnetr",
          "inicashbala",
          "fincashbala",
        ];
        if (!that.checkShowBt(bbqbzbList, notShow, "bbqbzb_tit")) {
          notShow.push("bbqbzb_tit");
        }
      }
      that.showKeys = notShow;
    },
    checkShowBt: function (titData, showData, titStr) {
      let arr = [];
      titData.forEach(function (item) {
        if (showData.indexOf(item) === -1) {
          arr.push(item);
        }
      });
      if (arr.length > 0) {
        return titStr;
      } else {
        return false;
      }
    },
    // food点击切换
    switchTab: function (type) {
      let that = this;
      that.foodType = type;
      that.dataQuery = [];
      that.seaOn = 0;
      that.tongbi = false;
      that.showKeys = [];
      that.$nextTick(function () {
        that.queryData();
      });
    },
    scroll: function () {
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      this.contentWidth = document.getElementById("scrollHeadDom").offsetWidth;
      this.fixed = scrollTop >= this.headTop;
      if (this.fixed) {
        this.$nextTick((_) => {
          this.scrollHead();
        });
      }
    },
    scrollHead: function () {
      let el = document.getElementById("scrollHeadDom");
      if (el) {
        let left = el.scrollLeft;
        let fixed = document.getElementById("fixedDom");
        if (fixed) {
          fixed.scrollLeft = left;
        }
      }
    },
    getOffsetTop(dom, distance) {
      distance = distance || 0;
      if (["BODY", null].indexOf(dom.offsetParent.nodeName) >= 0) {
        distance += dom.offsetTop;
        return distance;
      } else {
        distance += dom.offsetTop;
        return this.getOffsetTop(dom.offsetParent, distance);
      }
    },
    checkIndext: function (num) {
      if (num === 2) {
        return "indext2";
      }
    },
    goLinkDetail: function (item) {
      if (this.isFullScreen) {
        this.fullScreen();
      }

      window.location.href =
        "/cwts_details?code=" +
        this.getUrlQuery("code") +
        "&type=" +
        this.topNavId +
        "&key=" +
        item.key +
        "&DZHSPECIAL=1";
    },
    onDrag(e) {
      let el = this.$refs.fullscreen;
      if (el) {
        el.style.top = e.touches[0].pageY - this.point.y + this.point.top + "px";
        el.style.left = e.touches[0].pageX - this.point.x + this.point.left + "px";
      }
      e.stopPropagation();
      e.preventDefault();
    },
    onDragStart(e) {
      let el = this.$refs.fullscreen;
      if (el) {
        this.point = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY,
          left: el.offsetLeft,
          top: el.offsetTop,
        };
      }
    },
    onDragEnd() {
      this.point = {};
    },
    fullScreen() {
      if (window.DzhAppJs) {
        let el = this.$refs.fullscreen;
        el.style.top = "auto";
        el.style.right = "30px";
        el.style.bottom = "80px";
        el.style.left = "auto";
        if (this.isFullScreen) {
          window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
            "screenPortrait",
            null,
            null
          );
          setTimeout(() => {
            window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
              "setTitleStyle",
              `{"navBarHidden":0,"titleBlackColor":"#FFFFFF","navBarBlackColor":"#1B1D25","titleWhiteColor":"#000000","navBarWhiteColor":"#FFFFFF","title":"${document.title}"}`,
              null
            );
          }, 100);
          this.isFullScreen = false;
        } else {
          window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
            "screenLandscape",
            null,
            null
          );
          setTimeout(() => {
            window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
              "setTitleStyle",
              `{"navBarHidden":1}`,
              null
            );
          }, 100);
          this.isFullScreen = true;
        }
        setTimeout(() => {
          this.getContentWidth();
        }, 1000);
      }
    },
    getContentWidth() {
      let width = window.innerWidth;
      let contentWidth = width * 0.55;
      if (contentWidth > 186) {
        contentWidth = width - 186;
      }
      this.contentWidth = contentWidth;
      document.querySelector("body").setAttribute("width", contentWidth + "px");
      this.ddHeight();
    },
  },
};
</script>
<style lang="less">
@import "../assets/css/cwts_more.less";
</style>
